import Quantity from '../components/quantity';
import CompositeCollapse from '../components/composite-collapse';

export default {
  init() {
    this.bindEvents()

    // Woocommerce events
    let wooEvents = [
      'init_checkout',
      'payment_method_selected',
      'update_checkout',
      'updated_checkout',
      'checkout_error',
      'wc_fragments_refreshed',
      'wc_fragments_loaded',
    ]
    wooEvents.map(event => {
      $(document.body).on(event, () => this.bindEvents())
    })
  },
  finalize () {
    // JavaScript to be fired on the home page, after the init JS
  },
  bindEvents () {
    let $quantity = new Quantity('.js-quantity')
    $quantity.init()
    let collapser = new CompositeCollapse('.js-collapse-composite')
    collapser.init()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerceCart.js